import { Search } from '@/DTOS/Report/Search';
import request from '../../utils/request';

const ReportOfferFinancialService = {
    collectionOfferFinancial: (search: Search) => {
        return request('/report/collectionOfferFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    paymentOfferFinancial: (search: Search) => {
        return request('/report/paymentOfferFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    balanceOfferFinancial: (search: Search) => {
        return request('/report/balanceOfferFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },
};

export default ReportOfferFinancialService;
